import { Injectable } from '@angular/core';
import { ApplicationState } from '../models/application-state';
import { SessionStorage } from '../../core/services/global/storage/session-storage.service';
import { isNullOrUndefined } from 'util';
@Injectable({
  providedIn: 'root'
})
export class ApplicationStateStorageService {

  APPLICATION_STATE = 'APPLICATION_STATE';

  private applicationState: ApplicationState;

  constructor(private sessionStorage: SessionStorage) { }

  updateApplicationState(): void {
    this.sessionStorage.put(this.APPLICATION_STATE, this.applicationState);
  }

  isApplicationState(): boolean {
    if (!isNullOrUndefined(this.getApplicationState())) {
      return true;
    }
    return false;
  }

  createApplicationState(applicationState: ApplicationState): void {
    this.applicationState = applicationState;

    this.updateApplicationState();
  }

  getApplicationState(): ApplicationState {
    return this.sessionStorage.get(this.APPLICATION_STATE);
  }

  setApplicationState(state: ApplicationState): void {
    this.applicationState = state;
  }

  removeState(): void {
    this.sessionStorage.remove(this.APPLICATION_STATE);
  }
}
